import React from 'react';

type SelectInputProps = {
  name: string;
  placeholder: {
    value: string | number;
    label: string;
  };
  value: string;
  options: Array<{ value: string | number; label: string }>;
  onChange: (value: React.ChangeEvent<HTMLSelectElement>) => void;
  className?: string;
  disabled?: boolean;
  error?: boolean;
  validator?: any;
  [x: string]: any;
};

function SelectInput({
  className,
  name,
  disabled,
  error,
  placeholder,
  value,
  onChange,
  validator,
  options,
  ...props
}: SelectInputProps) {
  return (
    <div className="relative">
      {validator}
      <select
        {...props}
        name={name}
        value={value}
        disabled={disabled}
        className={`${className} ${error ? 'border-river-red focus:!ring-river-red' : ''} ${
          value ? 'text-river-black font-poppins-medium' : 'text-gray-300  font-poppins-light'
        }`}
        onChange={!disabled ? onChange : undefined}
      >
        <option className="disabled" value={placeholder.value} disabled>
          {placeholder.label}
        </option>
        {options &&
          options.map(option => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
      </select>
    </div>
  );
}

export default SelectInput;
